module.exports = __webpack_public_path__ + "static/media/martial-arts-storyboard_1500px.d100a86e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/martial-arts-storyboard_1500px.jpg
// module id = 251
// module chunks = 1